import React, { useEffect } from 'react';
import { Menu, X } from 'lucide-react';

interface MobileMenuProps {
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isExpanded, setIsExpanded }) => {
  const toggleSidebar = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsExpanded(true);
        
        const overlay = document.querySelector('.mobile-menu-overlay');
        if (overlay) {
          overlay.classList.remove('active');
        }
      } else {
        const overlay = document.querySelector('.mobile-menu-overlay');
        if (overlay) {
          if (isExpanded) {
            overlay.classList.add('active');
          } else {
            overlay.classList.remove('active');
          }
        }
      }
    };
    
    handleResize();
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isExpanded, setIsExpanded]);

  return (
    <>
      {/* Mobile menu button */}
      <button 
        className="mobile-menu-button"
        onClick={toggleSidebar}
        aria-label={isExpanded ? 'Close menu' : 'Open menu'}
      >
        {isExpanded ? (
          <X className="w-5 h-5 text-violet-600" />
        ) : (
          <Menu className="w-5 h-5 text-violet-600" />
        )}
      </button>

      {/* Overlay for closing menu on tap outside */}
      <div 
        className={`mobile-menu-overlay ${isExpanded ? 'active' : ''}`}
        onClick={() => setIsExpanded(false)}
        aria-hidden="true"
      />
    </>
  );
};

export default MobileMenu;